module.exports = __webpack_public_path__ + "img/icon-activity-demo.ec38da5f.svg";